<template>
    <div class="group-access-item">
    <span class="ga d-flex align-items-center" v-for="(datas, index) in data.group_access" :key="index">
      <span class="name">{{ getNameById(datas) }}</span>
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-x-circle-fill ml-2"
          viewBox="0 0 16 16"
          @click="click(data.user_name, datas)"
          v-tooltip="{ content: 'Remove access', placement: 'top', triggers: 'hover' }"
      >
        <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
        />
      </svg>
    </span>
    </div>
</template>

<script >
export default {
    props: {
        data: {},
        name: {},
        click: {
            type: Function,
            default: () => {
            }
        }
    },
    data() {
        return{
            trialGroupAccessList: [
                { id: 'subqgvtop50', name: 'FA Alpha'},
                { id: 'subfaalphapulse', name: 'Fa Alpha Pulse' },
                { id: 'subappaccess', name: 'Everything' },
                { id: 'suballusaccess', name: 'Everything US (All Newsletters & US Database)' },
                { id: 'subappentiredb', name: 'Entire Database' },
                { id: 'subappafricadb', name: 'Africa & Latin America Database' },
                { id: 'subappasiadb', name: 'Asia Database' },
                { id: 'subappusdb', name: 'US Database' },
                { id: 'subappcredit', name: 'Credit Newsletters (VCWI, UAFRS)' },
                { id: 'subappequity', name: 'Equity Newsletters (VEII, VEIH, CLL, UAFRS, TSIL)' },
                { id: 'submacronewsletters', name: 'Market Phase Cycle' },
                { id: 'suballnewsletters', name: 'All Valens Research Newsletters' },
                { id: 'subappeuropedb', name: 'Europe Database' },
                { id: 'Trial', name: 'Trial' },
                { id: 'subtrial', name: 'Subtrial' },
    ],
        };
    },
    methods: {
        getNameById(id) {
            const foundItem = this.trialGroupAccessList.find(item => item.id === id);
            return foundItem ? foundItem.name : id;
        },
    }

}
</script>

<style lang="scss" scoped>
    .group-access-item {
        max-width: 350px;
        .ga {
            background: #bfbfbf;
            color: #000;
            padding: 0 5px 0 10px;
            border-radius: 9px;
            display: inline-flex;
            align-items: center;
            margin-right: 5px;
            margin-bottom: 5px;
            display: block;
            width: max-content;

            svg {
                color: #e3342f;
                background: white;
                border-radius: 50%;
                cursor: pointer;
            }
        }
    }
</style>
